import React, { useState, useRef } from 'react';
import { Button, Card, StepIndicator, ErrorAlert } from '../../../components/shared';

const STEPS = [
  { key: 'personal', label: 'Cá nhân' },
  { key: 'contact', label: 'Liên hệ' },
  { key: 'bank', label: 'Ngân hàng' },
  { key: 'photos', label: 'Ảnh xác thực' },
  { key: 'confirm', label: 'Xác nhận' },
];

const GENDER_OPTIONS = [
  { value: 'M', label: 'Nam' },
  { value: 'F', label: 'Nữ' },
];

const ID_TYPE_OPTIONS = [
  { value: '1', label: 'CMND' },
  { value: '2', label: 'CCCD' },
  { value: '3', label: 'Hộ chiếu' },
];

const VN_HO = ['Nguyen', 'Tran', 'Le', 'Pham', 'Hoang', 'Huynh', 'Phan', 'Vu', 'Vo', 'Dang', 'Bui', 'Do', 'Ho', 'Ngo', 'Duong', 'Ly'];
const VN_TEN_NAM = ['Anh', 'Bao', 'Cuong', 'Dat', 'Dung', 'Hai', 'Hieu', 'Hung', 'Huy', 'Khanh', 'Long', 'Minh', 'Nam', 'Phuc', 'Quan', 'Son', 'Tai', 'Thanh', 'Thinh', 'Tuan'];
const VN_TEN_NU = ['Anh', 'Chi', 'Dung', 'Ha', 'Hang', 'Hanh', 'Hoa', 'Huong', 'Lan', 'Linh', 'Mai', 'My', 'Nga', 'Nhi', 'Oanh', 'Phuong', 'Thao', 'Thu', 'Trang', 'Vy'];

function rand(arr) {
  return arr[Math.floor(Math.random() * arr.length)];
}

function randDigits(len) {
  let s = '';
  for (let i = 0; i < len; i++) s += Math.floor(Math.random() * 10);
  return s;
}

function randDate(minYear, maxYear) {
  const y = minYear + Math.floor(Math.random() * (maxYear - minYear + 1));
  const m = String(1 + Math.floor(Math.random() * 12)).padStart(2, '0');
  const d = String(1 + Math.floor(Math.random() * 28)).padStart(2, '0');
  return `${y}-${m}-${d}`;
}

function findCode(list, keyword) {
  const item = list.find((i) => (i.name || '').toLowerCase().includes(keyword));
  return item ? (item.code || item.value || '') : '';
}

function generateStepData(step, currentForm, catalogs) {
  const { provinces = [], banks = [], nationalities = [], issuePlaces = [] } = catalogs || {};
  const isMale = currentForm.gender !== 'F';

  switch (step) {
    case 0: {
      const ho = rand(VN_HO);
      const dem = isMale ? rand(['Van', 'Duc', 'Minh', 'Quoc', 'Hoang']) : rand(['Thi', 'Ngoc', 'Thanh', 'Xuan']);
      const ten = isMale ? rand(VN_TEN_NAM) : rand(VN_TEN_NU);
      return {
        fullName: `${ho} ${dem} ${ten}`,
        idType: '2',
        idNumber: '0' + randDigits(11),
        dateOfBirth: randDate(1985, 2002),
        gender: isMale ? 'M' : 'F',
        nationality: findCode(nationalities, 'vietnam') || findCode(nationalities, 'việt'),
        idIssueDate: randDate(2020, 2025),
        idIssuePlace: findCode(issuePlaces, 'hà nội') || findCode(issuePlaces, 'ha noi') || (issuePlaces[0]?.code || ''),
      };
    }
    case 1: {
      const name = currentForm.fullName || 'Nguyen Van A';
      const parts = name.split(' ');
      const emailName = `${parts[0]}${parts[parts.length - 1]}${randDigits(3)}`.toLowerCase().replace(/\s/g, '');
      return {
        phonePostal: '84',
        phoneNumber: '09' + randDigits(8),
        email: `${emailName}@gmail.com`,
        permanentAddress: `${Math.floor(Math.random() * 200) + 1} ${rand(['Nguyen Trai', 'Le Loi', 'Tran Hung Dao', 'Ly Thuong Kiet', 'Ba Trieu', 'Hai Ba Trung', 'Nguyen Du'])}`,
        provinceId: findCode(provinces, 'hà nội') || findCode(provinces, 'ha noi') || (provinces[0]?.code || ''),
      };
    }
    case 2: {
      return {
        bankId: findCode(banks, 'vietcombank') || findCode(banks, 'vcb') || (banks[0]?.code || ''),
        bankBranch: 'Ha Noi',
        bankAccountNo: randDigits(13),
        bankAccountName: (currentForm.fullName || 'NGUYEN VAN A').toUpperCase(),
      };
    }
    default:
      return {};
  }
}

function SelectField({ label, value, onChange, options, placeholder, required }) {
  return (
    <div>
      <label className="mb-1.5 block text-sm font-medium text-gray-700">{label}</label>
      <select
        value={value}
        onChange={(e) => onChange(e.target.value)}
        className="w-full rounded-lg border border-gray-300 bg-white px-3 py-2.5 text-sm focus:border-blue-500 focus:outline-none focus:ring-2 focus:ring-blue-500"
        required={required}
      >
        <option value="">{placeholder || 'Chọn...'}</option>
        {options.map((opt) => (
          <option key={opt.code || opt.value} value={opt.code || opt.value}>
            {opt.name || opt.label}
          </option>
        ))}
      </select>
    </div>
  );
}

function InputField({ label, value, onChange, type = 'text', placeholder, required }) {
  return (
    <div>
      <label className="mb-1.5 block text-sm font-medium text-gray-700">{label}</label>
      <input
        type={type}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        placeholder={placeholder}
        className="w-full rounded-lg border border-gray-300 px-3 py-2.5 text-sm focus:border-blue-500 focus:outline-none focus:ring-2 focus:ring-blue-500"
        required={required}
      />
    </div>
  );
}

function ImageUpload({ label, description, value, onChange }) {
  const inputRef = useRef(null);

  const handleChange = (e) => {
    const file = e.target.files[0];
    if (!file) return;
    const reader = new FileReader();
    reader.onload = () => onChange(reader.result);
    reader.readAsDataURL(file);
  };

  if (value) {
    return (
      <div>
        <label className="mb-1.5 block text-sm font-medium text-gray-700">{label}</label>
        <div className="relative">
          <img src={value} alt={label} className="h-40 w-full rounded-lg border border-gray-200 object-cover" />
          <button
            type="button"
            onClick={() => onChange('')}
            className="absolute right-2 top-2 rounded-full bg-white/80 p-1 text-gray-500 shadow hover:bg-white hover:text-red-500"
          >
            <svg className="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
              <path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12" />
            </svg>
          </button>
        </div>
      </div>
    );
  }

  return (
    <div>
      <label className="mb-1.5 block text-sm font-medium text-gray-700">{label}</label>
      <button
        type="button"
        onClick={() => inputRef.current?.click()}
        className="flex h-32 w-full flex-col items-center justify-center rounded-lg border-2 border-dashed border-gray-300 bg-gray-50 transition-colors hover:border-blue-400 hover:bg-blue-50"
      >
        <svg className="mb-2 h-8 w-8 text-gray-400" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={1.5}>
          <path strokeLinecap="round" strokeLinejoin="round" d="M2.25 15.75l5.159-5.159a2.25 2.25 0 013.182 0l5.159 5.159m-1.5-1.5l1.409-1.409a2.25 2.25 0 013.182 0l2.909 2.909M6.75 7.5h.008v.008H6.75V7.5zm0 0a1.5 1.5 0 11-3 0 1.5 1.5 0 013 0z" />
        </svg>
        <span className="text-sm text-gray-500">{description || 'Chọn ảnh (JPEG, PNG)'}</span>
        <input ref={inputRef} type="file" accept="image/jpeg,image/png" onChange={handleChange} className="hidden" />
      </button>
    </div>
  );
}

function ReviewRow({ label, value }) {
  return (
    <div className="flex justify-between border-b border-gray-50 py-2">
      <span className="text-sm text-gray-500">{label}</span>
      <span className="text-sm font-medium text-gray-900">{value || '—'}</span>
    </div>
  );
}

export default function RegisterFlow({ catalogs, onSubmit, onBack, loading, error }) {
  const [step, setStep] = useState(0);
  const [form, setForm] = useState({
    fullName: '',
    idNumber: '',
    idType: '2',
    dateOfBirth: '',
    gender: 'M',
    nationality: '',
    idIssueDate: '',
    idIssuePlace: '',
    phoneNumber: '',
    phonePostal: '84',
    email: '',
    permanentAddress: '',
    provinceId: '',
    bankId: '',
    bankBranch: '',
    bankAccountNo: '',
    bankAccountName: '',
    idFrontBase64: '',
    idBackBase64: '',
    selfieBase64: '',
  });

  const update = (field) => (value) => setForm((f) => ({ ...f, [field]: value }));

  const canNext = () => {
    switch (step) {
      case 0:
        return form.fullName && form.idNumber && form.dateOfBirth;
      case 1:
        return form.phoneNumber && form.email;
      case 2:
        return form.bankId && form.bankAccountNo && form.bankAccountName;
      case 3:
        return form.idFrontBase64 && form.idBackBase64 && form.selfieBase64;
      default:
        return true;
    }
  };

  const handleAutoFill = () => {
    const data = generateStepData(step, form, catalogs);
    setForm((f) => ({ ...f, ...data }));
  };

  const handleSubmit = () => {
    onSubmit(form);
  };

  const { provinces = [], banks = [], nationalities = [], issuePlaces = [], phonePostals = [] } = catalogs || {};

  const renderStep = () => {
    switch (step) {
      case 0:
        return (
          <div className="space-y-4">
            <InputField label="Họ và tên" value={form.fullName} onChange={update('fullName')} placeholder="Nhập họ và tên" required />
            <div className="grid grid-cols-2 gap-4">
              <SelectField label="Loại giấy tờ" value={form.idType} onChange={update('idType')} options={ID_TYPE_OPTIONS} />
              <InputField label="Số CMND/CCCD" value={form.idNumber} onChange={update('idNumber')} placeholder="Nhập số giấy tờ" required />
            </div>
            <div className="grid grid-cols-2 gap-4">
              <InputField label="Ngày sinh" value={form.dateOfBirth} onChange={update('dateOfBirth')} type="date" required />
              <SelectField label="Giới tính" value={form.gender} onChange={update('gender')} options={GENDER_OPTIONS} />
            </div>
            <SelectField label="Quốc tịch" value={form.nationality} onChange={update('nationality')} options={nationalities} placeholder="Chọn quốc tịch" />
            <div className="grid grid-cols-2 gap-4">
              <InputField label="Ngày cấp" value={form.idIssueDate} onChange={update('idIssueDate')} type="date" />
              <SelectField label="Nơi cấp" value={form.idIssuePlace} onChange={update('idIssuePlace')} options={issuePlaces} placeholder="Chọn nơi cấp" />
            </div>
          </div>
        );

      case 1:
        return (
          <div className="space-y-4">
            <div>
              <label className="mb-1.5 block text-sm font-medium text-gray-700">Số điện thoại</label>
              <div className="flex gap-2">
                {phonePostals.length > 0 ? (
                  <div className="w-28">
                    <select
                      value={form.phonePostal}
                      onChange={(e) => update('phonePostal')(e.target.value)}
                      className="w-full rounded-lg border border-gray-300 bg-white px-2 py-2.5 text-sm focus:border-blue-500 focus:outline-none focus:ring-2 focus:ring-blue-500"
                    >
                      {phonePostals.map((p) => {
                        const callingCode = p.extraData?.calling_code || p.code;
                        return (
                          <option key={p.code} value={callingCode}>+{callingCode}</option>
                        );
                      })}
                    </select>
                  </div>
                ) : (
                  <input
                    type="text"
                    value={form.phonePostal}
                    onChange={(e) => update('phonePostal')(e.target.value.replace(/\D/g, ''))}
                    className="w-20 rounded-lg border border-gray-300 px-3 py-2.5 text-center text-sm focus:border-blue-500 focus:outline-none focus:ring-2 focus:ring-blue-500"
                    placeholder="84"
                  />
                )}
                <input
                  type="tel"
                  value={form.phoneNumber}
                  onChange={(e) => update('phoneNumber')(e.target.value)}
                  placeholder="Số điện thoại"
                  className="flex-1 rounded-lg border border-gray-300 px-3 py-2.5 text-sm focus:border-blue-500 focus:outline-none focus:ring-2 focus:ring-blue-500"
                  required
                />
              </div>
            </div>
            <InputField label="Email" value={form.email} onChange={update('email')} type="email" placeholder="email@example.com" required />
            <InputField label="Địa chỉ thường trú" value={form.permanentAddress} onChange={update('permanentAddress')} placeholder="Nhập địa chỉ" />
            <SelectField label="Tỉnh/Thành phố" value={form.provinceId} onChange={update('provinceId')} options={provinces} placeholder="Chọn tỉnh/thành" />
          </div>
        );

      case 2:
        return (
          <div className="space-y-4">
            <SelectField label="Ngân hàng" value={form.bankId} onChange={update('bankId')} options={banks} placeholder="Chọn ngân hàng" required />
            <InputField label="Chi nhánh" value={form.bankBranch} onChange={update('bankBranch')} placeholder="Nhập chi nhánh" />
            <InputField label="Số tài khoản" value={form.bankAccountNo} onChange={update('bankAccountNo')} placeholder="Nhập số tài khoản" required />
            <InputField label="Tên chủ tài khoản" value={form.bankAccountName} onChange={update('bankAccountName')} placeholder="Nhập tên chủ tài khoản" required />
          </div>
        );

      case 3:
        return (
          <div className="space-y-4">
            <ImageUpload
              label="Ảnh mặt trước CMND/CCCD"
              description="Chụp rõ mặt trước giấy tờ"
              value={form.idFrontBase64}
              onChange={update('idFrontBase64')}
            />
            <ImageUpload
              label="Ảnh mặt sau CMND/CCCD"
              description="Chụp rõ mặt sau giấy tờ"
              value={form.idBackBase64}
              onChange={update('idBackBase64')}
            />
            <ImageUpload
              label="Ảnh chân dung cầm giấy tờ"
              description="Selfie cầm CMND/CCCD bên cạnh khuôn mặt"
              value={form.selfieBase64}
              onChange={update('selfieBase64')}
            />
          </div>
        );

      case 4:
        return (
          <div className="space-y-2">
            <h4 className="mb-3 font-medium text-gray-900">Xác nhận thông tin đăng ký</h4>
            <div className="rounded-lg bg-gray-50 p-4">
              <p className="mb-2 text-xs font-medium uppercase tracking-wide text-gray-500">Thông tin cá nhân</p>
              <ReviewRow label="Họ tên" value={form.fullName} />
              <ReviewRow label="Số giấy tờ" value={form.idNumber} />
              <ReviewRow label="Ngày sinh" value={form.dateOfBirth} />
              <ReviewRow label="Giới tính" value={form.gender === 'M' ? 'Nam' : 'Nữ'} />
            </div>
            <div className="rounded-lg bg-gray-50 p-4">
              <p className="mb-2 text-xs font-medium uppercase tracking-wide text-gray-500">Liên hệ</p>
              <ReviewRow label="Điện thoại" value={`+${form.phonePostal} ${form.phoneNumber}`} />
              <ReviewRow label="Email" value={form.email} />
              <ReviewRow label="Địa chỉ" value={form.permanentAddress} />
            </div>
            <div className="rounded-lg bg-gray-50 p-4">
              <p className="mb-2 text-xs font-medium uppercase tracking-wide text-gray-500">Ngân hàng</p>
              <ReviewRow label="Số TK" value={form.bankAccountNo} />
              <ReviewRow label="Tên TK" value={form.bankAccountName} />
            </div>
            <div className="rounded-lg bg-gray-50 p-4">
              <p className="mb-2 text-xs font-medium uppercase tracking-wide text-gray-500">Ảnh xác thực</p>
              <div className="mt-2 grid grid-cols-3 gap-2">
                {form.idFrontBase64 && <img src={form.idFrontBase64} alt="Mặt trước" className="h-20 w-full rounded border object-cover" />}
                {form.idBackBase64 && <img src={form.idBackBase64} alt="Mặt sau" className="h-20 w-full rounded border object-cover" />}
                {form.selfieBase64 && <img src={form.selfieBase64} alt="Chân dung" className="h-20 w-full rounded border object-cover" />}
              </div>
            </div>
          </div>
        );

      default:
        return null;
    }
  };

  const lastStep = STEPS.length - 1;

  return (
    <div className="mx-auto max-w-lg">
      <Card>
        <div className="space-y-6">
          <div className="flex items-start justify-between">
            <div>
              <h3 className="text-lg font-semibold text-gray-900">Đăng ký tài khoản Fmarket</h3>
              <p className="mt-1 text-sm text-gray-500">Điền thông tin để tạo tài khoản Fmarket mới</p>
            </div>
            {step <= 2 && (
              <button
                type="button"
                onClick={handleAutoFill}
                title="Auto fill"
                className="shrink-0 rounded-lg border border-gray-200 p-2 text-gray-400 transition-colors hover:border-blue-300 hover:bg-blue-50 hover:text-blue-600"
              >
                <svg className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={1.5}>
                  <path strokeLinecap="round" strokeLinejoin="round" d="M9.813 15.904L9 18.75l-.813-2.846a4.5 4.5 0 00-3.09-3.09L2.25 12l2.846-.813a4.5 4.5 0 003.09-3.09L9 5.25l.813 2.846a4.5 4.5 0 003.09 3.09L15.75 12l-2.846.813a4.5 4.5 0 00-3.09 3.09zM18.259 8.715L18 9.75l-.259-1.035a3.375 3.375 0 00-2.455-2.456L14.25 6l1.036-.259a3.375 3.375 0 002.455-2.456L18 2.25l.259 1.035a3.375 3.375 0 002.455 2.456L21.75 6l-1.036.259a3.375 3.375 0 00-2.455 2.456zM16.894 20.567L16.5 21.75l-.394-1.183a2.25 2.25 0 00-1.423-1.423L13.5 18.75l1.183-.394a2.25 2.25 0 001.423-1.423l.394-1.183.394 1.183a2.25 2.25 0 001.423 1.423l1.183.394-1.183.394a2.25 2.25 0 00-1.423 1.423z" />
                </svg>
              </button>
            )}
          </div>

          <StepIndicator steps={STEPS} currentStep={step} />

          {renderStep()}

          <ErrorAlert error={error} />

          <div className="flex gap-3">
            <Button
              variant="secondary"
              className="flex-1"
              onClick={step === 0 ? onBack : () => setStep(step - 1)}
              type="button"
            >
              {step === 0 ? 'Quay lại' : 'Trước'}
            </Button>
            {step < lastStep ? (
              <Button
                className="flex-1"
                onClick={() => setStep(step + 1)}
                disabled={!canNext()}
              >
                Tiếp tục
              </Button>
            ) : (
              <Button
                className="flex-1"
                onClick={handleSubmit}
                loading={loading}
              >
                Đăng ký
              </Button>
            )}
          </div>
        </div>
      </Card>
    </div>
  );
}
